import React from 'react';
import { connect } from '@common/components/base.component';
import loaderSelectors from '@common/store/loader/loader.selectors';

function LoaderContainer(props) {
  const { loader } = props.loaderSelectors;
  return (
    <>
      {loader && (
        <div className="loading-screen-blocker">
          <div className="loadingContent">
            <div className="loader" />
            <span>Carregando . . .</span>
          </div>
        </div>
      )}
    </>
  );
}

export default connect({
  selectors: {
    loaderSelectors,
  },
})(LoaderContainer);
